import { t } from 'i18next';
import { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';

import uploadIcon from '../../../assets/img/icons/upload.svg';
import {
  CommonFlex,
  CommonGrid,
  CommonImage,
  CommonText,
} from '../../../styledComponents/common';
import { CheckListNameInputField } from '../../../styledComponents/tasks';
import {
  DropZoneContainer,
  UpdateImageHoverDiv,
  UploadImageDiv,
} from '../../UserProfile/profileStyles';
import { ZoneButton } from '../officesStyles';

const dropZoneCss = {
  width: '100%',
  height: '150px',
  objectFit: 'cover',
  objectPosition: 'center',
  background: '#FFFFFF',
  border: '2px dotted #A2845E',
  borderRadius: '6px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
const dropZoneCssNoBorder = {
  width: '100%',
  height: '150px',
  objectFit: 'cover',
  objectPosition: 'center',
  background: '#FFFFFF',
  border: '2px dotted #A2845E',
  borderRadius: '6px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const PdfUploadSketch = ({ setFile, columns, file }) => {
  const [fileState, setFileState] = useState(null);

  const onDrop = acceptedFiles => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      const newFile = {
        file,
        name: file.name,
        preview: URL.createObjectURL(file),
        description: '',
      };
      setFileState(newFile);
      setFile(newFile);
    }
  };

  const handleDescriptionChange = value => {
    const updatedFile = { ...fileState, description: value };
    setFileState(updatedFile);
    setFile(updatedFile);
  };

  const removeFile = () => {
    setFileState(null);
    setFile(null);
  };

  useEffect(() => {
    if (file) {
      setFileState(file);
    } else {
      setFileState(null);
    }
  }, [file]);

  return (
    <div>
      {!fileState ? (
        <DropZoneContainer>
          <CommonGrid columns={columns || '1fr'}>
            <Dropzone
              style={fileState ? dropZoneCssNoBorder : dropZoneCss}
              onDrop={onDrop}
              accept="application/pdf"
              multiple={false}
            >
              {({
                isDragAccept,
                isDragReject,
                acceptedFiles,
                rejectedFiles,
              }) => (
                <div style={fileState ? dropZoneCssNoBorder : dropZoneCss}>
                  <input type="file" style={{ display: 'none' }} />
                  <UploadImageDiv
                    height="50px"
                    style={{
                      textAlign: 'center',
                    }}
                  >
                    <CommonImage src={uploadIcon} alt="Upload" size="24px" />
                    <CommonText fontSize="14px" margin="0">
                      {t('click_or_drop_here_to_upload')}
                    </CommonText>
                    <CommonText fontSize="12px" margin="0">
                      {t('max_1_pdf_file_is_allowed')}
                    </CommonText>
                  </UploadImageDiv>
                </div>
              )}
            </Dropzone>
          </CommonGrid>
        </DropZoneContainer>
      ) : (
        <CommonGrid columns="1fr" gap="20px">
          <CommonFlex
            style={{
              marginTop: '10px',
              padding: '10px',
              backgroundColor: '#E0BFB81F',
              borderRadius: '6px',
            }}
            direction="column"
          >
            <CommonFlex
              justifyContent="space-between"
              alignItems="center"
              gap="20px"
              width="100%"
            >
              <CommonText fontSize="14px" fontWeight="bold" active>
                {fileState.name}
              </CommonText>
              <ZoneButton
                fontWeight="600"
                onClick={removeFile}
                bgColor="#E0BFB8"
              >
                Remove
              </ZoneButton>
            </CommonFlex>
            <iframe
              src={
                typeof fileState === 'string' ? fileState : fileState.preview
              }
              title="PDF Preview"
              style={{ width: '100%', height: '350px', marginTop: '5px' }}
            />
          </CommonFlex>
        </CommonGrid>
      )}
    </div>
  );
};

export default PdfUploadSketch;
